export default __webpack_public_path__ + "static/media/MonarcaOpen.dd8285d9.jpg";